var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletMegaphone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0V0z",
    id: "ribwahfyta"
  }), /*#__PURE__*/React.createElement("path", {
    id: "366b5vdj5b",
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#ribwahfyta",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i5ehk91hnc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#366b5vdj5b"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i5ehk91hnc)",
    fill: "#02769D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 24.83 11.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.563 11.647h2.851V18H3.563zM3.176 10.941a3.176 3.176 0 0 1 0-6.353h3.238v6.353H3.176zM7.126 4.556l10.69-3.85v14.118l-10.69-3.85z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.529,
    width: 2.138,
    height: 15.529,
    rx: 1.069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.18 1.253a.716.716 0 0 0-1.008 0l-2.52 2.496a.703.703 0 0 0 0 .998.716.716 0 0 0 1.008 0l2.52-2.496a.703.703 0 0 0 0-.998zM28.18 14.276a.703.703 0 0 0 0-.998l-2.52-2.496a.716.716 0 0 0-1.008 0 .703.703 0 0 0 0 .999l2.52 2.495a.716.716 0 0 0 1.007 0zM31 7.765a.706.706 0 0 0-.706-.706h-4.29a.706.706 0 1 0 0 1.412h4.29c.39 0 .706-.316.706-.706zM21.38 5.647h.725c.78 0 1.412.632 1.412 1.413v1.41c0 .78-.632 1.412-1.412 1.412h-.726V5.647z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletMegaphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-megaphone.b25beab83bf3f33ea0819eb26f7a1f02.svg";